module.exports = __webpack_public_path__ + "img/bell.b8e620f7.svg";